import { FC } from 'react';

import { useCustomerStore, useEditStore } from 'page/NotificationPage/hooks';
import { ConfirmationModalView } from 'page/NotificationPage/components/ConfirmationModalView';

type Props = {
  handleClose: () => void;
  handleClickGoInput: () => void;
  handleClickUpdate: () => void;
};

export const ConfirmationModal: FC<Props> = ({
  handleClose,
  handleClickGoInput,
  handleClickUpdate,
}) => {
  const {
    isOpenConfirmationModal,
    title,
    message,
    isHigh,
    startDate,
    endDate,
    conditionForDisplay,
    shouldShowCustomerList,
  } = useEditStore();
  const { selectedCustomers, selectedCustomersLength } = useCustomerStore();

  return (
    <>
      {/* 確認モーダル */}
      <ConfirmationModalView
        mode="更新"
        isOpen={isOpenConfirmationModal}
        title={title}
        message={message}
        isHigh={isHigh}
        startDate={startDate}
        endDate={endDate}
        conditionForDisplay={conditionForDisplay}
        shouldShowCustomerList={shouldShowCustomerList}
        selectedCustomers={selectedCustomers}
        selectedCustomersLength={selectedCustomersLength}
        handleClose={handleClose}
        handleClickGoInput={handleClickGoInput}
        handleClickExecution={handleClickUpdate}
      />
    </>
  );
};
